import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import process from '@/components/examine/process.vue';
import newProgress from '@/components/examine/newProgress.vue';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
import { auditSchedule, auditDetail, auditOperate } from './request';
import sharedNode from './components/sharedNode.vue';
import currentNode from './components/currentNode.vue';
import previewFileModel from '@/views/components/previewFile/previewFileModel.vue';
import emailSendModel from '@/views/components/emailSend/emailSendModel.vue';
export default {
  components: {
    process,
    newProgress,
    sharedNode,
    currentNode,
    previewFileModel,
    emailSendModel
  },
  data() {
    return {
      scheduleList: [],
      procedureList: [],
      step: 0,
      scheduleInfo: {},
      detailsObj: null,
      previewFileList: [],
      showPreviewFile: false,
      showSendEmail: false,
      notifyData: null,
      echoNodeIsEdit: null,
      //回显区可编辑状态true可编辑false不可编辑
      editSharedNodeInfo: [],
      //回显区可以编辑的数据
      crrentNodeIsEdit: true,
      loading: false
    };
  },
  created() {
    this.getInfoFun();
    this.$store.dispatch('quiretionnaire/getResource');
  },
  methods: {
    goInfoFun(val) {
      this.scheduleInfo = val;
      this.stepFun();
      this.detailFun();
    },
    async detailFun() {
      this.detailsObj = null;
      const res = await auditDetail({
        auditScheduleId: this.scheduleInfo.id
      });
      console.log(res, this.$route.params.type, '-------详情----------');
      /**
       * 操作按钮进入$route.params.type == 2可以编辑
       * 查看按钮进入$route.params.type == 1不可以编辑
       */
      if (this.$route.params.type == 2) {
        this.crrentNodeIsEdit = true;
        this.$nextTick(function () {
          // 判断回显节点是否可编辑
          if (res.renderState === 'EDIT') {
            this.echoNodeIsEdit = true;
            res.sharedNodeInfo.forEach(item => {
              if (item.isEdit === true) {
                item.echoNodeIsEdit = true;
              } else {
                item.echoNodeIsEdit = false;
              }
            });
          } else {
            this.echoNodeIsEdit = false;
          }
        });
        this.$forceUpdate();
      } else {
        console.log('-----不可以编辑------');
        this.$route.meta.title = this.$t('问卷查看');
        this.crrentNodeIsEdit = false;
        this.echoNodeIsEdit = false;
      }
      this.detailsObj = res;
    },
    async getInfoFun() {
      const res = await auditScheduleResource({
        auditFlowTypeId: this.$route.params.auditFlowTypeId
      });
      if (res.length != 0) {
        this.procedureList = res;
      }
      this.getscheduleFun();
    },
    async getscheduleFun() {
      this.scheduleList = await auditSchedule({
        auditFlowDetailId: this.$route.params.id
      });
      this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
      console.log(this.scheduleInfo, 'this.scheduleInfo');
      if (!this.scheduleInfo.currentScheduleOperator && !this.scheduleInfo.operationAt && this.scheduleInfo.step == '0') {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 2];
      }
      this.stepFun();
      this.detailFun();
    },
    stepFun() {
      this.step = this.procedureList.findIndex(val => {
        return val.id == this.scheduleInfo.auditFlowScheduleId;
      });
      if (this.step == -1) {
        this.step = 0;
      }
    },
    // 按钮点击
    onSubmit(buttonItem) {
      if (this.detailsObj.sharedNodeInfo.length > 0) {
        this.$refs.sharedNode.onSubmit();
      }
      if (this.detailsObj.editableAreaInfo.length > 0) {
        this.$refs.currentArea.onSubmit();
      }
      let status = true;
      if (this.detailsObj.sharedNodeInfo.length > 0 && status) {
        status = this.$refs.sharedNode.vidateStatus;
      }
      if (this.detailsObj.editableAreaInfo.length > 0 && status) {
        status = this.$refs.currentArea.vidateStatus;
      }
      if (status) {
        var _this$$refs$currentAr, _this$$refs$sharedNod;
        // 所有校验成功
        // 处理回显节点isEdit:true的情况
        if (this.detailsObj.sharedNodeInfo.length > 0) {
          this.editSharedNodeInfo = JSON.parse(JSON.stringify(this.detailsObj.sharedNodeInfo));
          this.editSharedNodeInfo.forEach((item, index) => {
            if (item.isEdit === false) {
              this.editSharedNodeInfo.splice(index, 1);
            }
          });
        }
        let editSubmitArea = this.$refs.currentArea && (_this$$refs$currentAr = this.$refs.currentArea.submitData) !== null && _this$$refs$currentAr !== void 0 && _this$$refs$currentAr.length ? this.$refs.currentArea.submitData : '';
        let shareSubmitArea = this.$refs.sharedNode && (_this$$refs$sharedNod = this.$refs.sharedNode.submitData) !== null && _this$$refs$sharedNod !== void 0 && _this$$refs$sharedNod.length ? this.$refs.sharedNode.submitData : '';
        if (buttonItem.goBack === 'PREVIEW_FILE') {
          //附件按钮
          this.$set(buttonItem, 'url', undefined);
          let params = {
            auditScheduleId: this.scheduleInfo.id,
            editableArea: JSON.stringify(editSubmitArea),
            sharedNodeInfo: JSON.stringify(shareSubmitArea),
            actionButton: buttonItem
          };
          this.showPreviewFile = true;
          this.requestSave(params, 'PREVIEW_FILE');
        } else {
          //如果按钮有发送邮件的功能 打开发送邮件的弹窗
          if (buttonItem.notify.length > 0) {
            this.notifyData = buttonItem;
            this.showSendEmail = true;
            this.$nextTick(() => {});
          } else {
            let params = {
              auditScheduleId: this.scheduleInfo.id,
              editableArea: JSON.stringify(editSubmitArea),
              sharedNodeInfo: shareSubmitArea ? JSON.stringify(shareSubmitArea) : '',
              actionButton: buttonItem
            };
            this.requestSave(params);
          }
        }
      } else {
        this.$message.error(this.$t('请填写完整'));
        return;
      }
    },
    // 提交接口
    requestSave(params, type) {
      this.loading = true;
      auditOperate(params).then(res => {
        this.loading = false;
        if (type === 'PREVIEW_FILE') {
          var _res$previewFiles;
          this.previewFileList = [];
          (_res$previewFiles = res.previewFiles) === null || _res$previewFiles === void 0 || _res$previewFiles.forEach((item, index) => {
            this.previewFileList.push({
              name: item.fileName,
              url: item.filePath,
              uid: index + 1,
              status: 'done'
            });
          });
        } else {
          this.$message.success('提交成功');
          this.$router.push('/examine/questionnaireExamine');
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    restPreviewFile() {
      this.previewFileList = [];
      this.showPreviewFile = false;
    },
    // 发送邮件回调
    closeModel(notifyData) {
      var _this$$refs$currentAr2, _this$$refs$sharedNod2;
      console.log(notifyData, '-------发送邮件掉接口------');
      let editSubmitArea = this.$refs.currentArea && (_this$$refs$currentAr2 = this.$refs.currentArea.submitData) !== null && _this$$refs$currentAr2 !== void 0 && _this$$refs$currentAr2.length ? this.$refs.currentArea.submitData : '';
      let shareSubmitArea = this.$refs.sharedNode && (_this$$refs$sharedNod2 = this.$refs.sharedNode.submitData) !== null && _this$$refs$sharedNod2 !== void 0 && _this$$refs$sharedNod2.length ? this.$refs.sharedNode.submitData : '';
      let params = {
        auditScheduleId: this.scheduleInfo.id,
        editableArea: JSON.stringify(editSubmitArea),
        sharedNodeInfo: JSON.stringify(shareSubmitArea),
        actionButton: notifyData
      };
      this.requestSave(params);
    }
  }
};